function isPathOnTerminalNode(pathGraphFlow, terminalNodeId) {
  var terminalNodeIndex = pathGraphFlow.nodes.findIndex(function (node) {
    return node.id === terminalNodeId;
  });
  var lastNodeIndex = pathGraphFlow.nodes.length - 1;
  return terminalNodeIndex === lastNodeIndex;
}

export default isPathOnTerminalNode;
//# sourceMappingURL=isPathOnTerminalNode.js.map
